<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-26 10:25:36
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-22 10:29:38
 * @FilePath: \合联\wms\src\view\forecastManagement\doorToDoor\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis, uploads } from "@/api/forecastManagement/doorToDoor";

export default {
  name: "doorToDoor",
  components: {
    cTable,
  },
  mounted() {},
  data() {
    return {
      methods: {
        ...apis,
        uploads,
      },
      config: {},
      footer: {},
      modals: {
        log: {
          config: {
            title: this.$tz("操作,记录"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("操作,类型"),
                key: "type_name",
                minWidth: 130,
              },
              {
                name: () => this.$t("操作人"),
                key: "create_name",
                minWidth: 130,
              },
              {
                name: () => this.$t("操作,时间"),
                key: "create_time",
                minWidth: 130,
              },
              {
                name: () => this.$tz("仓库"),
                key: "warehouse_name",
                minWidth: 110,
              },
              {
                name: () => this.$tz("文件"),
                key: "src",
                minWidth: 110,
                component: "Button",
                bind: {
                  size: "small",
                  type: "primary",
                },
                disabled({ value }) {
                  return !value;
                },
                methods: {
                  render() {
                    return this.$tz("查看");
                  },
                  click({ value }) {
                    window.open(value);
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "dataType",
            placeholder() {
              return this.$tz("时间,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "MEN_TIME_TYPE",
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            name: this.$tz("国家"),
            key: "country",
            component: "Select",
            placeholder: () => this.$tz("国家"),
            options: [],
            optionsFn: "toCountry",
            optionsKey: "",
            default: "",
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "getAllClient",
            optionsKey: "",
          },
          {
            key: "delivery_status",
            placeholder() {
              return this.$tz("是否,派送");
            },
            component: "Select",
            options: [
              { label: this.$tz("是"), value: 1 },
              { label: this.$tz("否"), value: 2 },
            ],
            optionsFn: "",
            optionsKey: "",
          },
          {
            key: "pod_status",
            placeholder() {
              return this.$tz("是否,签收");
            },
            component: "Select",
            options: [
              { label: this.$tz("是"), value: 1 },
              { label: this.$tz("否"), value: 2 },
            ],
            optionsFn: "",
            optionsKey: "",
          },
          {
            key: "transport_code",
            placeholder() {
              return this.$tz("运输模式");
            },
            component: "Select",
            options: [],
            optionsFn: "method",
            optionsKey: "",
          },
          {
            key: "status_name",
            placeholder() {
              return this.$tz("当前状态");
            },
            component: "Select",
            options: [],
            optionsFn: "getTrackerStatus",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            // {
            //   name: () => this.$tz("出派"),
            //   type: "delivery",
            //   fnName: "delivery",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     type: "primary",
            //   },
            // },
            // {
            //   name: this.$tz("上传,签收单"),
            //   type: "upload",
            //   fnName: "upload",
            //   bind: {
            //     type: "primary",
            //   },
            // },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            upload({ row }) {
              // 新建一个上传批量文件按钮，然后点击
              const input = document.createElement("input");
              input.type = "file";
              input.multiple = true;
              input.click();
              input.onchange = () => {
                const files = input.files;
                const formData = new FormData();
                for (let i = 0; i < files.length; i++) {
                  formData.append("files[]", files[i]);
                }
                this.handleRequestMethods("uploads", formData, true, true).then(
                  (res) => {
                    this.getList();
                  }
                );
              };
            },
            delivery() {
              this.$Modal.confirm({
                title: this.$tz("出派"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "delivery",
                    { ids: this.selectAll.map((t) => t.id) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("订单号码"),
          key: "airway_number",
          minWidth: 130,
        },
        {
          name: () => this.$tz("目的国家"),
          key: "to_country",
          minWidth: 130,
        },
        {
          name: () => this.$tz("客户名称"),
          key: "account",
          minWidth: 130,
        },
        {
          name: () => this.$tz("运输方式"),
          key: "transport",
          minWidth: 130,
        },
        {
          name: () => this.$tz("订单状态"),
          key: "status_name",
          minWidth: 130,
        },
        {
          name: () => this.$tz("状态时间"),
          key: "status_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("状态描述"),
          key: "status_remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("Company name"),
          key: "shipper_company_cn",
          minWidth: 130,
        },
        {
          name: () => this.$t("Appointment delivery Time"),
          key: "delivery_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("pod_time1"),
          key: "pod_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("ReceiptSign"),
          key: "oms_receipt",
          minWidth: 130,
          component: "Button",
          bind: {
            size: "small",
            type: "primary",
          },
          disabled({ value, row }) {
            return !value;
          },
          methods: {
            render() {
              return this.$tz("查看");
            },
            click({ value }) {
              window.open(value);
            },
          },
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("操作,记录"),
              type: "record",
              fnName: "record",
              bind: {
                type: "primary",
              },
              id: 1804,
            },
          ],
          methods: {
            record({ row }) {
              this.handleRequestMethods(
                "log",
                { id: row.id },
                false,
                true
              ).then((res) => {
                this.getModal("log").open({}, function () {
                  this.list = res.payload;
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
